module.exports = __webpack_public_path__ + "files/66cf159f1e1278b27850ac19bf780ce4.png";